<script lang="ts" setup>
import { computed, useId } from "vue";
import { useField } from "vee-validate";

const props = defineProps({
  modelValue: {
    type: null,
  },
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
  },
});

const fieldName = computed(() => props.name);
const { checked, handleChange } = useField(fieldName, undefined, {
  type: "checkbox",
  checkedValue: props.value,
});

const baseId = useId();
const labelId = computed(() => `${props.name}-label-${baseId}`);
const buttonId = computed(() => `${props.name}-${baseId}`);
</script>

<template>
  <div class="custom-checkbox" :class="checked ? 'checked' : 'unchecked'">
    <button
      :id="buttonId"
      type="button"
      role="checkbox"
      :aria-checked="!!checked"
      :aria-labelledby="labelId"
      @click="handleChange(value)"
    >
      <span>
        <svg
          viewBox="0 0 50 50"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fill="none"
            stroke="white"
            stroke-width="4"
            d="M5 25 L20 40 L45 10"
            stroke-linecap="round"
            stroke-dasharray="60"
            stroke-dashoffset="60"
            class="tick"
          ></path>
        </svg>
      </span>
    </button>
    <span :id="labelId" class="label-text">
      <slot>
        {{ value }}
      </slot>
    </span>
  </div>
</template>
